class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.megaMenuContent = null;
    this.megaMenuPlaceholder = null;
    this.isNavigating = false;
    this.onReposition = this.onReposition.bind(this);
    this.onMegaMenuPointerDown = this.onMegaMenuPointerDown.bind(this);
  }

  onMegaMenuPointerDown(event) {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href === '#' || href.trim().toLowerCase().startsWith('javascript:')) return;

    // Keep the portaled menu in place so the browser can follow the link.
    this.isNavigating = true;
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.isNavigating) return;

      const active = document.activeElement;
      const portaledMenu = this.getPortaledMenu();
      const focusInsideMenu =
        this.contains(active) || (portaledMenu && portaledMenu.contains(active));

      if (!focusInsideMenu) this.close();
    });
  }

  getPortaledMenu() {
    if (this.megaMenuContent?.classList.contains('berri-mega-menu__content--portaled')) {
      return this.megaMenuContent;
    }
    return document.querySelector('.berri-mega-menu__content--portaled');
  }

  close() {
    if (this.isNavigating) return;
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.isNavigating = false;
      this.portalMegaMenu();
      this.onReposition();
      window.addEventListener('resize', this.onReposition);
      window.addEventListener('scroll', this.onReposition, { passive: true });
    } else {
      this.restoreMegaMenuPortal();
      window.removeEventListener('resize', this.onReposition);
      window.removeEventListener('scroll', this.onReposition);
    }

    super.onToggle();
  }

  portalMegaMenu() {
    this.megaMenuContent = this.mainDetailsToggle.querySelector('.berri-mega-menu__content');
    if (!this.megaMenuContent || this.megaMenuContent.classList.contains('berri-mega-menu__content--portaled')) return;

    this.megaMenuPlaceholder = document.createComment('berri-mega-menu-placeholder');
    this.megaMenuContent.parentNode.insertBefore(this.megaMenuPlaceholder, this.megaMenuContent);
    document.body.appendChild(this.megaMenuContent);
    this.megaMenuContent.classList.add('berri-mega-menu__content--portaled');
    document.body.classList.add('berri-mega-menu-open');
    this.megaMenuContent.addEventListener('pointerdown', this.onMegaMenuPointerDown);
  }

  restoreMegaMenuPortal() {
    if (!this.megaMenuContent || !this.megaMenuPlaceholder?.parentNode) return;
    // Don't move the menu DOM while a link navigation is in progress.
    if (this.isNavigating) return;

    this.megaMenuContent.removeEventListener('pointerdown', this.onMegaMenuPointerDown);
    this.megaMenuPlaceholder.parentNode.insertBefore(this.megaMenuContent, this.megaMenuPlaceholder);
    this.megaMenuPlaceholder.remove();
    this.megaMenuPlaceholder = null;
    this.megaMenuContent.classList.remove('berri-mega-menu__content--portaled');
    this.megaMenuContent.style.removeProperty('top');
    document.body.classList.remove('berri-mega-menu-open');
  }

  onReposition() {
    if (!this.header || !this.megaMenuContent) return;

    const bottom = Math.floor(this.header.getBoundingClientRect().bottom);
    this.megaMenuContent.style.top = `${bottom}px`;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${bottom}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
